import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  ConfigService,
  KibanaEntityType,
  KibanaLog,
  KibanaLogsService,
  REF_MODEL_STORE,
  RefModelNode,
  RefModelStoreService,
  Refmodel,
  TakeUntilComponentDestroy
} from '@q9elements/ui-kit/common';
import {includes} from 'lodash';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss']
})
export class SidebarHeaderComponent extends TakeUntilComponentDestroy implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() isRefModel: boolean;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() followLevel: number;

  @Output() updateFollow: EventEmitter<any> = new EventEmitter();

  followState: 'following' | 'favourite' | null;
  refModel: Refmodel;
  node$: Observable<RefModelNode>;
  linkType$: Observable<string>;
  node: RefModelNode;
  areNodesDeleting$: Observable<boolean>;
  areNodesDeleting: boolean;

  sfSetupTriggered: string[] = [];
  apiEndpoint = ConfigService.environment.API_ENDPOINT;

  constructor(
    private rmeStore: RefModelStoreService,
    private kibanaLog: KibanaLogsService
  ) {
    super();
  }

  ngOnInit() {
    this.refModel = this.rmeStore.refModel;
    this.node$ = this.rmeStore.select<RefModelNode>(REF_MODEL_STORE.SELECTED_NODE);
    this.node$.pipe(this.takeUntilComponentDestroy()).subscribe((node: RefModelNode) => {
      if (node) {
        this.getFollowState(node.followLevel);
        this.node = {...node};
      }
    });
    this.linkType$ = this.rmeStore.select(REF_MODEL_STORE.LINK_TYPE);
    this.areNodesDeleting$ = this.rmeStore.select(REF_MODEL_STORE.ARE_NODES_DELETING);
    this.areNodesDeleting$
      .pipe(this.takeUntilComponentDestroy())
      .subscribe((areNodesDeleting: boolean) => {
        this.areNodesDeleting = areNodesDeleting;
      });
  }

  isNodeDeleting(): boolean {
    return this.areNodesDeleting && this.node.status === 'deleted';
  }

  toggleFollow() {
    if (this.isNodeDeleting()) {
      return;
    }

    this.updateFollow.emit();
  }

  getFollowState(followLevel: number) {
    switch (followLevel) {
      case 0:
        this.followState = 'following';
        break;
      case 1:
        this.followState = 'favourite';
        break;
      default:
        this.followState = null;
        break;
    }
  }

  sendKibanaLog(node: RefModelNode): void {
    if (includes(this.sfSetupTriggered, node._id)) {
      return;
    }
    const logData: KibanaLog = {
      entityId: this.refModel._id,
      entityType: KibanaEntityType.REFERENCE_MODEL,
      eventType: 'Salesforce setup launched'
    };
    this.kibanaLog
      .sendKibanaLog(logData)
      .pipe(tap(() => this.sfSetupTriggered.push(node._id)))
      .subscribe();
  }

  ngOnDestroy(): void {
    return;
  }
}
